/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    assunto: "",
    mensagem: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "telefone") {
      const masked = formatPhone(value);
      setFormData((prev) => ({ ...prev, telefone: masked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setStatus("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const telefoneLimpo = formData.telefone.replace(/\D/g, "");
    if (telefoneLimpo.length < 10) {
      setStatus("❌ Telefone inválido.");
      return;
    }

    const formUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLScoeZjlOtv5C_UrH3kmfCVsGZS2i520du7xKlcuIttXkM4h9A/formResponse";

    const data = new URLSearchParams();
    data.append("entry.1727962677", formData.nome); // Nome
    data.append("entry.1594692395", formData.email); // Email
    data.append("entry.1756386957", `55${telefoneLimpo}`); // Telefone com DDD
    data.append("entry.510880514", formData.assunto); // Assunto
    data.append("entry.1126663117", formData.mensagem); // Mensagem

    setStatus("Enviando...");

    await fetch(formUrl, {
      method: "POST",
      mode: "no-cors",
      body: data,
    });

    setFormData({
      nome: "",
      email: "",
      telefone: "",
      assunto: "",
      mensagem: "",
    });
    setStatus("✅ Mensagem enviada com sucesso!");
  };

  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length <= 2) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length <= 10)
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(
      7,
      11
    )}`;
  };

  return (
    <div className="py-16 bg-blue-950 sm:px-4">
      <div className="container mx-auto pt-12 sm:px-4">
        <h1 className="text-4xl font-bold text-white mb-8 text-center">
          Entre em Contato
        </h1>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden sm:mb-12">
          <div className="md:flex">
            {/* FORMULÁRIO */}
            <div className="w-full md:w-1/2 p-8">
              <h2 className="text-2xl font-bold text-blue-950 mb-6">
                Fale Conosco
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label
                    htmlFor="nome"
                    className="block text-gray-700 font-medium mb-2"
                  >
                    Nome Completo
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Digite seu nome"
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-gray-700 font-medium mb-2"
                  >
                    E-mail
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Digite seu e-mail"
                  />
                </div>

                <div>
                  <label
                    htmlFor="telefone"
                    className="block text-gray-700 font-medium mb-2"
                  >
                    Telefone/WhatsApp
                  </label>
                  <input
                    type="tel"
                    id="telefone"
                    inputMode="tel"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="(00) 00000-0000"
                  />
                </div>

                <div>
                  <label
                    htmlFor="assunto"
                    className="block text-gray-700 font-medium mb-2"
                  >
                    Assunto
                  </label>
                  <select
                    id="assunto"
                    name="assunto"
                    value={formData.assunto}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Selecione um assunto</option>
                    <option value="Solicitar Cotação">Solicitar Cotação</option>
                    <option value="Dúvidas sobre Seguros">
                      Dúvidas sobre Seguros
                    </option>
                    <option value="Comunicar Sinistro">
                      Comunicar Sinistro
                    </option>
                    <option value="Outro Assunto">Outro Assunto</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="mensagem"
                    className="block text-gray-700 font-medium mb-2"
                  >
                    Mensagem
                  </label>
                  <textarea
                    id="mensagem"
                    name="mensagem"
                    value={formData.mensagem}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Digite sua mensagem"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="bg-blue-800 hover:bg-blue-900 text-white font-medium py-3 px-6 rounded-md w-full md:w-auto"
                >
                  Enviar Mensagem
                </button>

                {status && (
                  <p className="text-sm font-medium mt-2 text-blue-900">
                    {status}
                  </p>
                )}
              </form>
            </div>

            {/* CONTATO */}
            <div className="w-full md:w-1/2 bg-gray-900 text-white p-8 overflow-auto md:overflow-visible">
              <h2 className="text-2xl font-bold mb-6">
                Informações de Contato
              </h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-blue-700 p-3 rounded-full mr-4">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg">Endereço</h3>
                    <p className="text-blue-200">
                      Rua Gameleiras, 141 - 2 Andar - Campestre
                      <br />
                      São Gotardo - MG, CEP 38800-000
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-blue-700 p-3 rounded-full mr-4">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg">Telefone</h3>
                    <p className="text-blue-200">(34) 3671-0353</p>
                    <p className="text-blue-200">(34) 3671-0349 (WhatsApp)</p>
                    <br />
                    <p className="text-blue-200 font-bold">
                      Assistência 24h (Sinistro):
                    </p>
                    <p className="text-blue-200">(34) 9 9919-3810 (WhatsApp)</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-blue-700 p-3 rounded-full mr-4">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg">E-mail</h3>
                    <p className="text-blue-200">
                      contato@freemarketseguros.com.br
                    </p>
                    <p className="text-blue-200">
                      recepcao@freemarketseguros.com.br
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-blue-700 p-3 rounded-full mr-4">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg">
                      Horário de Atendimento
                    </h3>
                    <p className="text-blue-200">Segunda a Sexta: 8h às 18h</p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <h3 className="font-semibold text-lg mb-4">Redes Sociais</h3>
                <div className="flex space-x-4">
                  <a
                    href="https://www.facebook.com/freemarketcorretoradesguros"
                    className="bg-blue-700 hover:bg-blue-600 w-10 h-10 rounded-full flex items-center justify-center"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/freemarketseguros/"
                    className="bg-blue-700 hover:bg-blue-600 w-10 h-10 rounded-full flex items-center justify-center"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/freemarketseguros"
                    className="bg-blue-700 hover:bg-blue-600 w-10 h-10 rounded-full flex items-center justify-center"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a
                    href="https://wa.me/553436710349"
                    className="bg-blue-700 hover:bg-blue-600 w-10 h-10 rounded-full flex items-center justify-center"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MAPA */}
        <div className="bg-white shadow-lg sm:rounded-lg overflow-hidden">
          <div className="p-6">
            <h2 className="text-2xl font-bold text-blue-800 mb-4">
              Localização
            </h2>
            <div className="bg-gray-200 h-96 flex items-center justify-center">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.7887671250313!2d-46.05099492394827!3d-19.31099998196729!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ae5b8a5e6b3f5d%3A0x8e6a8a1a9f0d8a0!2sR.%20Gameleiras%2C%20141%20-%20Campestre%2C%20S%C3%A3o%20Gotardo%20-%20MG%2C%2038800-000!5e0!3m2!1spt-BR!2sbr!4v1654321234567!5m2!1spt-BR!2sbr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
